import { Layout } from 'app/layout/layout.types';

export type LayoutOption = {
    id: Layout;
    label: string;
};

export const LAYOUT_OPTIONS: LayoutOption[] = [
    { id: 'empty', label: 'Empty' },
    { id: 'classic', label: 'Classic' },
    { id: 'classy', label: 'Classy' },
    { id: 'compact', label: 'Compact' },
    { id: 'dense', label: 'Dense' },
    { id: 'futuristic', label: 'Futuristic' },
    { id: 'thin', label: 'Thin' },
    { id: 'centered', label: 'Centered' },
    { id: 'enterprise', label: 'Enterprise' },
    { id: 'material', label: 'Material' },
    { id: 'modern', label: 'Modern' },
];
